<div class="center d-flex flex-column">
  <mat-icon class="h1">error_outline</mat-icon>
  <div i18n>Pripojenie bolo prerušené.</div>
  <div><span i18n>Pokračujte na </span>&nbsp;<a href="/ais/logout.do" i18n>prihlasovaciu stránku</a>.</div>
</div>
